import { H4, P } from "@/components/ui/typography";
import { ContainerPrimary, ContainerSecondary } from "../ui";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE, ROLE } from "@/utils/constant";
import { useDownloadHPDB, useIntegrationHPDBs } from "@/api/generate-hpdb";
import { convertUppercaseLabelToCapitalize } from "../utils/convertUppercaseLabelToCapitalize";
import { DownloadButton } from "@/components/ui/button";
import { swalErrorDefault, swalSuccess } from "@/utils/lib/swal";
import { useCurrentUser } from "@/features/auth/useCurrentUser";

export function GenerateHPDBHandler() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { roles } = useCurrentUser();
  const canAccess =
    roles?.includes(ROLE.ADMINISTRATOR) ||
    roles?.includes(ROLE.VALIDATOR_DOCUMENT_OFFICER) ||
    roles?.includes(ROLE.MONITORING_TEAM);

  const { data: integrationHPDBs } = useIntegrationHPDBs({ rfsId: id });
  const integrationHPDB = integrationHPDBs?.[0];

  const { mutate: download, isPending: isDownloading } = useDownloadHPDB();

  function handleDownload() {
    if (!id) {
      throw new Error(MISSING_ID_IN_ROUTE);
    }
    download(
      {
        id,
        name: `HPDB-${integrationHPDB?.rfs.clusterId}.xlsx`,
      },
      {
        onSuccess: () => {
          swalSuccess.fire({
            text: "HPDB has been downloaded successfully",
          });
        },
        onError: () => {
          swalErrorDefault.fire();
        },
      },
    );
  }

  return (
    <ContainerPrimary>
      <div className="flex-grow whitespace-nowrap">
        <H4>Generate HPDB</H4>
      </div>
      <ContainerSecondary>
        <P className="flex-grow text-axiata-blue dark:text-neutral-300">
          {convertUppercaseLabelToCapitalize(integrationHPDB?.status)}
        </P>
        {canAccess && (
          <DownloadButton
            onClick={handleDownload}
            loading={isDownloading}
            className="ml-auto"
            disabled={!integrationHPDB}
          >
            Download
          </DownloadButton>
        )}
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
